// Turnit keeps the calling code with a leading plus, while `PhoneInput` holds it
// digit-only to match the values of its country `<select>`. Serialize the code
// here, at the API boundary, so the internal representation never becomes the
// wire value: `372` and `+372` both go out as `+372`, an empty code stays empty.
export const toApiPhoneAreaCode = (areaCode) => {
  const digits = `${areaCode || ""}`.trim().replace(/^\++/, "");

  return digits ? `+${digits}` : "";
};
